import { css } from '@emotion/react';

import type { Brand } from '../../types/brand';

const paragraphNestedLinkStyles = (theme: Brand, variant = 'primary') => {
  let color: string;

  switch (variant) {
    case 'primaryAlternate':
    case 'secondaryAlternate':
      color = theme.colors.coolGrey[100];
      break;

    case 'primaryInverse':
    case 'secondaryInverse':
      color = 'white';
      break;

    default:
      color = theme.colors.hyperlink;
  }

  return css([
    {
      a: {
        color,
        fontWeight: theme.fontWeights.fw500,
        '&:focus-visible': {
          outline: 'thin solid',
          outlineOffset: '2px',
        },
        '&:hover, &:focus-visible': {
          fontWeight: theme.fontWeights.fw400,
        },
      },
    },
    variant?.includes('secondary') && {
      a: {
        fontWeight: theme.fontWeights.fw400,
        '&:hover, &:focus': {
          fontWeight: theme.fontWeights.fw500,
        },
      },
    },
  ]);
};

export default paragraphNestedLinkStyles;
